// Mock data for SOLARIAN website

export const siteSettings = {
  siteName: "SOLARIAN",
  companyFullName: "SOLARIAN ASTRA PRIVATE LIMITED",
  email: "sales@solarianastra.com",
  phone: "+91 8383924885",
  whatsapp: "https://wa.me/918383924885",
  
  counters: {
    projectsMW: 250,
    ppasDelivered: 45
  },
  
  socialLinks: {
    linkedin: "https://www.linkedin.com/company/solarianastra",
    youtube: "https://youtube.com/@solarian",
    instagram: "https://www.instagram.com/solarianastra/",
    twitter: "https://x.com/SolarianAstra",
    facebook: "https://www.facebook.com/people/Solarian-Astra-Pvt-Ltd/61564881573844/",
    whatsapp: "https://wa.me/918383924885"
  },
  
  offices: {
    head: {
      name: "Head Office",
      address: "WeWork, 1st Floor, Galaxy Business Park, A-44 & 45, Block A, Industrial Area, Sector 62, Noida, Uttar Pradesh, PIN - 201309",
      mapUrl: "https://www.google.com/maps/dir//1st+floor,+WeWork+Galaxy+Business+Park,+GALAXY+BUSINESS+PARK,+WeWork,+A-44+%26+45,+Sushil+Marg,+Block+A,+Industrial+Area,+Sector+62,+Noida,+Uttar+Pradesh+201309/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x390ce5001363af3f:0xf19ad2a71ae53863?sa=X&ved=1t:57443&ictx=111"
    },
    haryana: {
      name: "Haryana Office",
      address: "WeWork, Forum DLF Cyber City, DLF Cyber City, DLF Phase 3, Sector 24, Gurugram, Haryana, PIN - 122002",
      mapUrl: "https://www.google.com/maps/place/WeWork+Forum/data=!4m2!3m1!1s0x0:0xb8120a4412f7ea62?sa=X&ved=1t:2428&ictx=111"
    },
    maharashtra: {
      name: "Maharashtra Office",
      address: "Shop No.2, Ground Floor, Bhakti Darshan, Sector-18, Ulwe, Navi Mumbai, Maharashtra, PIN - 410206",
      mapUrl: "https://www.google.com/maps/place/Bhakti+Darshan/data=!4m2!3m1!1s0x0:0xcbfff033b4a5180d?sa=X&ved=1t:2428&ictx=111"
    },
    rajasthan: {
      name: "Rajasthan Office",
      address: "B/486, Laxmi Chand Sanwal Colony, Jaisalmer, Rajasthan, PIN - 345001",
      mapUrl: "https://maps.app.goo.gl/uJA3AbuqDV2A2Lzv9"
    }
  }
};

export const heroContent = {
  headline: "Tailored Renewable Energy Solutions & Regulatory Expertise",
  subheadline: "SOLARIAN provides customised renewable energy solutions and regulatory & legal advisory for developers and EPC companies across India.",
  ctaPrimary: "Get Tailored Solutions",
  ctaSecondary: "Request a Consultation",
  heroImage: "https://images.pexels.com/photos/11678747/pexels-photo-11678747.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
};

export const aboutContent = {
  intro: "Solarian Astra Private Limited is a renewable energy consultancy specialising in regulatory approvals, statutory compliance and turnkey advisory for developers and EPCs. We blend technical expertise with regulatory insight to accelerate renewable projects.",
  vision: "To power a sustainable future through innovative renewable energy strategies.",
  mission: "Deliver expert regulatory, legal, and consulting services to developers and EPCs for seamless renewable transitions.",
  heroImage: "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?crop=entropy&cs=srgb&fm=jpg&q=85",
  milestones: [
    { year: "2020", title: "Company Founded", description: "Started operations in renewable energy consulting" },
    { year: "2021", title: "100 MW Milestone", description: "Delivered regulatory approvals for 100 MW projects" },
    { year: "2022", title: "Pan-India Presence", description: "Expanded to serve clients across India" },
    { year: "2023", title: "250 MW Achievement", description: "Successfully delivered over 250 MW in project consulting" }
  ]
};

export const services = {
  pillars: [
    {
      id: "renewable",
      title: "Renewable Energy Consulting",
      icon: "Sun",
      summary: "Comprehensive consulting for solar and renewable energy projects",
      link: "/renewable-consulting"
    },
    {
      id: "regulatory",
      title: "Regulatory Consultancy",
      icon: "FileCheck",
      summary: "Expert regulatory approvals and compliance for developers & EPCs",
      link: "/regulatory-consultancy"
    },
    {
      id: "legal",
      title: "Legal Advisory",
      icon: "Scale",
      summary: "Legal support for licensing, contracts, and regulatory disputes",
      link: "/legal-advisory"
    }
  ]
};

export const filterRegulatoryServices = (list) => list.filter((s) => !s.hidden);

export const regulatoryServices = [
  {
    id: "ptcc",
    hidden: true,
    title: "PTCC Process",
    slug: "ptcc-process",
    description: "Power Transmission Clearance Certificate for electrical installations and connections",
    image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=85",
    process: [
      "Application submission with technical details",
      "Site inspection and assessment",
      "Technical evaluation and review",
      "Clearance certificate issuance"
    ],
    documents: ["Site layout plan", "Electrical single line diagram", "Load calculations", "Safety compliance certificate"],
    timeline: "4-8 weeks",
    benefits: "Ensure electrical safety compliance and smooth project commissioning"
  },
  {
    id: "ceig",
    hidden: true,
    title: "CEIG Process",
    slug: "ceig-process",
    description: "Chief Electrical Inspector General approval for electrical installations",
    image: "https://images.unsplash.com/photo-1508791290064-c27cc1ef7a9a?crop=entropy&cs=srgb&fm=jpg&q=85",
    process: [
      "Documentation preparation",
      "Technical review submission",
      "Inspection scheduling",
      "Approval and certification"
    ],
    documents: ["Installation drawings", "Equipment specifications", "Safety protocols", "Contractor licenses"],
    timeline: "6-10 weeks",
    benefits: "Legal compliance for high-voltage installations and operations"
  },
  {
    id: "section68",
    hidden: true,
    title: "Section-68",
    slug: "section-68",
    description: "Indian Electricity Act Section 68 approval for overhead lines",
    image: "https://images.unsplash.com/photo-1548337138-e87d889cc369?crop=entropy&cs=srgb&fm=jpg&q=85",
    process: [
      "Route survey and documentation",
      "Authority application",
      "Technical evaluation",
      "Permission grant"
    ],
    documents: ["Route map", "Technical specifications", "Safety clearances", "Land documents"],
    timeline: "8-12 weeks",
    benefits: "Legal permission for overhead transmission line installations"
  },
  {
    id: "section164",
    hidden: true,
    title: "Section-164",
    slug: "section-164",
    description: "Approval for works near transmission lines and electrical installations",
    image: "https://images.pexels.com/photos/9229394/pexels-photo-9229394.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    process: [
      "Proximity assessment",
      "Safety protocol development",
      "Application submission",
      "Approval issuance"
    ],
    documents: ["Site plan", "Work methodology", "Safety measures", "Clearance certificates"],
    timeline: "4-6 weeks",
    benefits: "Safe execution of works near high-voltage installations"
  },
  {
    id: "transmission-crossing",
    title: "Transmission Line Crossing Process",
    slug: "transmission-line-crossing",
    description: "Approvals for crossing transmission lines with new infrastructure",
    image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&q=85",
    process: [
      "Crossing point identification",
      "Technical feasibility study",
      "Multi-authority coordination",
      "Crossing permission grant"
    ],
    documents: ["Crossing diagram", "Technical calculations", "Safety protocols", "Insurance documents"],
    timeline: "10-16 weeks",
    benefits: "Coordinated approvals for complex transmission line crossings"
  },
  {
    id: "highways-crossing",
    title: "National & State Highways Crossing Process",
    slug: "highways-crossing",
    description: "Permissions for underground/overhead crossings of national and state highways",
    image: "https://images.pexels.com/photos/9799712/pexels-photo-9799712.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    process: [
      "Highway authority consultation",
      "Traffic impact assessment",
      "Technical design approval",
      "Execution permission"
    ],
    documents: ["Highway crossing plan", "Traffic management plan", "Restoration plan", "Bank guarantee"],
    timeline: "8-14 weeks",
    benefits: "Minimize traffic disruption and ensure highway safety compliance"
  },
  {
    id: "aviation",
    title: "Civil Aviation and Defence Aviation",
    slug: "aviation-clearance",
    description: "Aviation clearances for structures and installations near airports and airspace",
    image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=85",
    process: [
      "Height and location assessment",
      "Aviation authority application",
      "Aeronautical study",
      "No-objection certificate"
    ],
    documents: ["Site coordinates", "Structure height details", "Lighting plan", "Safety compliance"],
    timeline: "12-20 weeks",
    benefits: "Compliance with aviation safety regulations and airspace management"
  },
  {
    id: "water-body",
    title: "Water Body",
    slug: "water-body-clearance",
    description: "Environmental and regulatory clearances for projects near water bodies",
    image: "https://images.unsplash.com/photo-1508791290064-c27cc1ef7a9a?crop=entropy&cs=srgb&fm=jpg&q=85",
    process: [
      "Environmental impact assessment",
      "Water authority consultation",
      "Clearance application",
      "Approval and monitoring"
    ],
    documents: ["EIA report", "Water quality assessment", "Mitigation plan", "NOC from water board"],
    timeline: "16-24 weeks",
    benefits: "Environmental compliance and sustainable project execution"
  },
  {
    id: "bridge-authority",
    title: "Bridge Authority",
    slug: "bridge-authority-clearance",
    description: "Approvals for installations on or near bridge structures",
    image: "https://images.unsplash.com/photo-1548337138-e87d889cc369?crop=entropy&cs=srgb&fm=jpg&q=85",
    process: [
      "Structural assessment",
      "Bridge authority coordination",
      "Load calculation and approval",
      "Installation permission"
    ],
    documents: ["Structural drawings", "Load analysis", "Safety measures", "Restoration plan"],
    timeline: "6-10 weeks",
    benefits: "Safe installations without compromising bridge structural integrity"
  }
];

export const legalServices = [
  {
    id: "licensing",
    title: "Licensing Requirements",
    description: "Complete support for obtaining and maintaining required licenses for renewable energy operations"
  },
  {
    id: "tariff",
    title: "Tariff Adoption Process",
    description: "Expert guidance through tariff approval processes with regulatory commissions"
  },
  {
    id: "contracts",
    title: "Contract Adjudication",
    description: "Legal support for contract disputes and adjudication proceedings"
  },
  {
    id: "force-majeure",
    title: "Force Majeure",
    description: "Advisory on force majeure claims and contractual protections"
  },
  {
    id: "change-law",
    title: "Change in Law",
    description: "Legal assistance for change-in-law claims and compensation"
  },
  {
    id: "trading-disputes",
    title: "Power Trading Disputes",
    description: "Resolution of power trading disputes between parties"
  },
  {
    id: "ppa-disputes",
    title: "PPA Disputes",
    description: "Legal support for Power Purchase Agreement disputes"
  },
  {
    id: "license-surrender",
    title: "License Surrender Processes",
    description: "Guidance through license surrender and closure procedures"
  },
  {
    id: "hypothecation",
    title: "Section 17.3 and 17.4 Permissions",
    description: "Hypothecation permissions when changing banks or lenders"
  }
];

export const renewableServices = [
  {
    id: "general-consulting",
    title: "General Consulting",
    slug: "general-consulting",
    icon: "Cpu",
    description: "AI-powered renewable energy assessment based on your 12-month electricity consumption",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85",
    fullDescription: "Our General Consulting service provides comprehensive renewable energy solutions tailored to your specific requirements. We analyze your 12-month electricity bills, perform detailed load flow studies, and run advanced modeling through our AI system to recommend the optimal renewable energy solution.",
    deliverables: [
      "12-month electricity bill analysis",
      "Load flow studies and demand profiling",
      "AI-powered solution modeling",
      "Right solution at right terms with right partner",
      "Techno-commercial feasibility report",
      "Implementation roadmap"
    ],
    process: [
      "Submit 12 months of electricity bills",
      "Our AI system analyzes consumption patterns",
      "Load flow studies and demand forecasting",
      "Multiple solution scenarios generated",
      "Partner matching based on requirements",
      "Detailed proposal with ROI analysis"
    ],
    benefits: "Get data-driven recommendations powered by AI that match you with the perfect renewable energy solution and trusted implementation partners"
  },
  {
    id: "rooftop-ground",
    title: "Roof Top / Ground Mounted",
    slug: "rooftop-ground-mounted",
    icon: "Building2",
    description: "End-to-end consulting for rooftop and ground-mounted solar installations",
    image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=85",
    fullDescription: "Comprehensive consulting services for both rooftop and ground-mounted solar installations. We guide you through site assessment, system design, regulatory approvals, and implementation support.",
    deliverables: [
      "Site feasibility analysis",
      "Shadow analysis and yield assessment",
      "System design and engineering",
      "Regulatory approvals support",
      "Vendor selection assistance",
      "Commissioning support"
    ],
    process: [
      "Initial site assessment",
      "Technical feasibility study",
      "Financial modeling",
      "Regulatory clearances",
      "Implementation oversight"
    ],
    benefits: "Maximize your solar potential with expert guidance from feasibility to commissioning"
  },
  {
    id: "captive",
    title: "Captive",
    slug: "captive-power",
    icon: "Factory",
    description: "Captive power plant consulting for industrial and commercial consumers",
    image: "https://images.unsplash.com/photo-1508791290064-c27cc1ef7a9a?crop=entropy&cs=srgb&fm=jpg&q=85",
    fullDescription: "Specialized consulting for captive power plants that serve your own electricity needs. We help you achieve energy independence and cost savings through dedicated renewable capacity.",
    deliverables: [
      "Load analysis and plant sizing",
      "Open access approvals",
      "Wheeling & banking agreements",
      "Compliance support",
      "Commercial structuring",
      "Commissioning assistance"
    ],
    process: [
      "Consumption pattern analysis",
      "Captive plant sizing",
      "Regulatory approvals",
      "Land & grid connectivity",
      "Implementation support"
    ],
    benefits: "Achieve energy security and long-term cost savings with dedicated captive power"
  },
  {
    id: "group-captive",
    title: "Group Captive",
    slug: "group-captive",
    icon: "Users",
    description: "Group captive models for multiple consumers sharing renewable capacity",
    image: "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?crop=entropy&cs=srgb&fm=jpg&q=85",
    fullDescription: "Structure group captive arrangements where multiple consumers share renewable energy capacity. Ideal for industrial parks, commercial complexes, or consortium of businesses.",
    deliverables: [
      "Consumer aggregation strategy",
      "SPV structuring and governance",
      "Equity distribution framework",
      "Regulatory filings and approvals",
      "Offtake agreements drafting",
      "Commercial negotiations"
    ],
    process: [
      "Identify and aggregate consumers",
      "Structure legal entity (SPV)",
      "Define shareholding pattern",
      "Regulatory approvals",
      "Agreement execution"
    ],
    benefits: "Share renewable capacity and reduce costs through collaborative consumption"
  },
  {
    id: "discom",
    title: "Discom",
    slug: "discom-ppa",
    icon: "Zap",
    description: "Projects for selling power to distribution companies",
    image: "https://images.unsplash.com/photo-1548337138-e87d889cc369?crop=entropy&cs=srgb&fm=jpg&q=85",
    fullDescription: "Consulting for renewable energy projects that sell power to DISCOM utilities under Power Purchase Agreements (PPAs).",
    deliverables: [
      "PPA negotiations support",
      "Tariff optimization strategies",
      "Grid connectivity coordination",
      "DISCOM interface management",
      "Compliance management",
      "Project monitoring support"
    ],
    process: [
      "Market assessment",
      "PPA terms negotiation",
      "Regulatory approvals",
      "Grid connectivity",
      "Commercial operations"
    ],
    benefits: "Secure long-term power off-take with predictable returns through DISCOM PPAs"
  },
  {
    id: "virtual-ppa",
    title: "Virtual PPA",
    slug: "virtual-ppa",
    icon: "Cloud",
    description: "Virtual power purchase agreements for corporate renewable procurement",
    image: "https://images.pexels.com/photos/9229394/pexels-photo-9229394.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    fullDescription: "Structure virtual PPAs that allow corporates to procure renewable energy without physical delivery. Perfect for meeting sustainability goals and renewable energy commitments.",
    deliverables: [
      "Market analysis and pricing",
      "Contract structuring",
      "Risk assessment and hedging",
      "Banking mechanism design",
      "State-level strategy",
      "RECs and compliance support"
    ],
    process: [
      "Corporate renewable goals assessment",
      "Virtual PPA structuring",
      "Banking arrangements",
      "Contract finalization",
      "Ongoing management"
    ],
    benefits: "Meet renewable energy goals through flexible virtual arrangements without physical infrastructure"
  }
];

export const projects = [
  {
    id: "proj1",
    title: "50 MW Solar Park - Rajasthan",
    slug: "50mw-solar-park-rajasthan",
    mw: 50,
    location: "Jaisalmer, Rajasthan",
    type: "Ground Mounted",
    client: "ABC Developers Pvt Ltd",
    summary: "Complete regulatory and technical consulting for a 50 MW solar park including statutory approvals, land approvals, and grid connectivity clearances.",
    outcome: "Successfully commissioned within 14 months with all regulatory approvals in place.",
    images: [
      "https://images.pexels.com/photos/11678747/pexels-photo-11678747.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.pexels.com/photos/9229394/pexels-photo-9229394.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    ],
    challenges: "Multiple land parcels requiring coordinated approvals",
    approach: "Parallel processing of approvals with proactive stakeholder engagement",
    thumbnail: "https://images.pexels.com/photos/11678747/pexels-photo-11678747.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: "proj2",
    title: "Group Captive 25 MW - Maharashtra",
    slug: "group-captive-25mw-maharashtra",
    mw: 25,
    location: "Pune, Maharashtra",
    type: "Group Captive",
    client: "XYZ Industries Consortium",
    summary: "Structured and executed group captive model for 8 industrial consumers with complete regulatory compliance.",
    outcome: "Achieved 30% reduction in power costs for all consortium members.",
    images: [
      "https://images.unsplash.com/photo-1508791290064-c27cc1ef7a9a?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?crop=entropy&cs=srgb&fm=jpg&q=85"
    ],
    challenges: "Complex multi-party agreements and equity structuring",
    approach: "Detailed legal framework with clear governance mechanisms",
    thumbnail: "https://images.unsplash.com/photo-1508791290064-c27cc1ef7a9a?crop=entropy&cs=srgb&fm=jpg&q=85"
  },
  {
    id: "proj3",
    title: "Rooftop Solar 5 MW - Delhi NCR",
    slug: "rooftop-solar-5mw-delhi",
    mw: 5,
    location: "Noida, Uttar Pradesh",
    type: "Rooftop",
    client: "Corporate Office Complex",
    summary: "Distributed rooftop solar across multiple buildings with net metering approvals.",
    outcome: "Annual savings of ₹4.2 Cr with 8-year payback period.",
    images: [
      "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.pexels.com/photos/9799712/pexels-photo-9799712.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    ],
    challenges: "Limited roof space and structural constraints",
    approach: "Optimized layout with high-efficiency modules and structural reinforcement",
    thumbnail: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&q=85"
  },
  {
    id: "proj4",
    title: "100 MW Wind-Solar Hybrid - Gujarat",
    slug: "100mw-hybrid-gujarat",
    mw: 100,
    location: "Kutch, Gujarat",
    type: "Hybrid",
    client: "Green Energy Corp",
    summary: "Hybrid wind-solar project with complex transmission line crossing approvals.",
    outcome: "First-of-its-kind hybrid project in the region with 42% capacity utilization.",
    images: [
      "https://images.unsplash.com/photo-1548337138-e87d889cc369?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?crop=entropy&cs=srgb&fm=jpg&q=85"
    ],
    challenges: "Coordinating wind and solar regulatory frameworks",
    approach: "Integrated approval strategy with single-window clearances",
    thumbnail: "https://images.unsplash.com/photo-1548337138-e87d889cc369?crop=entropy&cs=srgb&fm=jpg&q=85"
  },
  {
    id: "proj5",
    title: "Virtual PPA 30 MW - Pan India",
    slug: "virtual-ppa-30mw-pan-india",
    mw: 30,
    location: "Multiple States",
    type: "Virtual PPA",
    client: "Tech Corporation",
    summary: "Structured virtual PPA for corporate renewable energy procurement across multiple states.",
    outcome: "100% renewable energy credits with optimized pricing structure.",
    images: [
      "https://images.pexels.com/photos/11678747/pexels-photo-11678747.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    ],
    challenges: "Multi-state regulatory coordination and banking mechanisms",
    approach: "Innovative banking arrangement with multiple discoms",
    thumbnail: "https://images.pexels.com/photos/11678747/pexels-photo-11678747.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: "proj6",
    title: "Captive Solar 15 MW - Karnataka",
    slug: "captive-solar-15mw-karnataka",
    mw: 15,
    location: "Bengaluru, Karnataka",
    type: "Captive",
    client: "Manufacturing Unit",
    summary: "Dedicated captive solar plant with open access approvals and wheeling agreements.",
    outcome: "Reduced grid dependency by 70% with stable power supply.",
    images: [
      "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=85"
    ],
    challenges: "Complex open access regulations and banking charges",
    approach: "Optimized consumption scheduling to minimize charges",
    thumbnail: "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=85"
  }
];

export const team = [
  {
    id: "member1",
    name: "Rajesh Kumar",
    role: "Founder & CEO",
    bio: "15+ years in renewable energy sector with expertise in regulatory consulting and project development.",
    photo: "https://ui-avatars.com/api/?name=Rajesh+Kumar&size=400&background=10B981&color=fff",
    linkedin: "https://linkedin.com/in/rajeshkumar"
  },
  {
    id: "member2",
    name: "Priya Sharma",
    role: "Head of Regulatory",
    bio: "Expert in power sector regulations with 12+ years experience in statutory approvals.",
    photo: "https://ui-avatars.com/api/?name=Priya+Sharma&size=400&background=0EA5E9&color=fff",
    linkedin: "https://linkedin.com/in/priyasharma"
  },
  {
    id: "member3",
    name: "Amit Patel",
    role: "Head of Technical",
    bio: "Electrical engineer with deep expertise in solar and hybrid project design.",
    photo: "https://ui-avatars.com/api/?name=Amit+Patel&size=400&background=10B981&color=fff",
    linkedin: "https://linkedin.com/in/amitpatel"
  },
  {
    id: "member4",
    name: "Neha Gupta",
    role: "Head of Legal",
    bio: "Energy law specialist with experience in PPA negotiations and regulatory disputes.",
    photo: "https://ui-avatars.com/api/?name=Neha+Gupta&size=400&background=0EA5E9&color=fff",
    linkedin: "https://linkedin.com/in/nehagupta"
  },
  {
    id: "member5",
    name: "Vikram Singh",
    role: "Senior Project Manager",
    bio: "10+ years managing large-scale solar and wind projects across India.",
    photo: "https://ui-avatars.com/api/?name=Vikram+Singh&size=400&background=10B981&color=fff",
    linkedin: "https://linkedin.com/in/vikramsingh"
  },
  {
    id: "member6",
    name: "Anjali Reddy",
    role: "Business Development Manager",
    bio: "Strategic partnerships and client relationship management expert.",
    photo: "https://ui-avatars.com/api/?name=Anjali+Reddy&size=400&background=0EA5E9&color=fff",
    linkedin: "https://linkedin.com/in/anjalireddy"
  }
];

export const partners = [
  { id: "p1", name: "Partner Company 1", logo: "https://via.placeholder.com/200x80/10B981/FFFFFF?text=Partner+1" },
  { id: "p2", name: "Partner Company 2", logo: "https://via.placeholder.com/200x80/0EA5E9/FFFFFF?text=Partner+2" },
  { id: "p3", name: "Partner Company 3", logo: "https://via.placeholder.com/200x80/10B981/FFFFFF?text=Partner+3" },
  { id: "p4", name: "Partner Company 4", logo: "https://via.placeholder.com/200x80/0EA5E9/FFFFFF?text=Partner+4" },
  { id: "p5", name: "Partner Company 5", logo: "https://via.placeholder.com/200x80/10B981/FFFFFF?text=Partner+5" }
];

export const customers = [
  { id: "c1", name: "Customer Company 1", logo: "https://via.placeholder.com/200x80/0EA5E9/FFFFFF?text=Client+1" },
  { id: "c2", name: "Customer Company 2", logo: "https://via.placeholder.com/200x80/10B981/FFFFFF?text=Client+2" },
  { id: "c3", name: "Customer Company 3", logo: "https://via.placeholder.com/200x80/0EA5E9/FFFFFF?text=Client+3" },
  { id: "c4", name: "Customer Company 4", logo: "https://via.placeholder.com/200x80/10B981/FFFFFF?text=Client+4" },
  { id: "c5", name: "Customer Company 5", logo: "https://via.placeholder.com/200x80/0EA5E9/FFFFFF?text=Client+5" },
  { id: "c6", name: "Customer Company 6", logo: "https://via.placeholder.com/200x80/10B981/FFFFFF?text=Client+6" }
];

export const testimonials = [
  {
    id: "test1",
    name: "Suresh Menon",
    company: "ABC Solar Developers",
    role: "CEO",
    text: "SOLARIAN's regulatory expertise helped us navigate complex approvals seamlessly. Their proactive approach saved us months in project timelines.",
    rating: 5
  },
  {
    id: "test2",
    name: "Kavita Desai",
    company: "Green Energy EPC",
    role: "Project Director",
    text: "Outstanding legal and technical support. The team's deep knowledge of power sector regulations is unmatched.",
    rating: 5
  },
  {
    id: "test3",
    name: "Arjun Mehta",
    company: "Renewable Solutions Ltd",
    role: "Managing Director",
    text: "From statutory clearances to grid approvals, SOLARIAN handled everything efficiently. Highly recommend their services.",
    rating: 5
  },
  {
    id: "test4",
    name: "Deepa Iyer",
    company: "Solar Ventures Inc",
    role: "Operations Head",
    text: "Professional, responsive, and results-driven. SOLARIAN is our go-to partner for all regulatory matters.",
    rating: 5
  }
];
